import { FC } from "react";

import { RestoreCaseSessionModalProps } from "./types";

const RestoreCaseSessionModal: FC<RestoreCaseSessionModalProps> = ({ isModalVisible, restoringCaseData, removeCurrentData }): JSX.Element => {
  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''}`}
      id="exampleModal"
      tabIndex={-1}
      data-bs-backdrop="static"
    >
      <div className="modal-dialog" style={{ maxWidth: '50rem' }}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="my-2 fw-semibold" id="exampleModalLabel">Warning</h5>
          </div>

          <div className="modal-body">
            <p className="mb-0">
              It seems that you were in the middle of enrolling a patient but did not finish it. Would you like 
              to continue with that previous enrollment?
            </p>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-danger text-end" onClick={removeCurrentData}>No, discard the previous enrollment and let me continue cloning this current one</button>
            <button type="button" className="btn btn-secondary" onClick={restoringCaseData}>Yes, let me continue with my previous enrollment</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestoreCaseSessionModal;
